import {
	SettingsStateActions,
	SettingsState,
	SET_SETTINGS,
	SET_SOFA_RANGE,
	SET_FEATURES,
	SET_KOMPIS_SETTINGS,
} from './types';
import { UrlService, localeService } from '../../services';
import { ApplicationUtils } from '../../util/ApplicationUtils/ApplicationUtils';

const initialState: SettingsState = {
	settings: {
		consumer: 'FIRST',
		contract: '36341',
		locale: localeService.getLocale(),
		applicationName: UrlService.getSofaRange(),
		applicationNameTranslated: '',
		translationEndpointApplication: 'FIRST',
		dexfApplicationId: '',
		translationPrefixApplication: ApplicationUtils.isProduction()
			? UrlService.getSofaRange().toUpperCase()
			: UrlService.getSofaRange(),
		environment: ApplicationUtils.isProduction() ? 'production' : 'test',
		localizationPrefixApplication: UrlService.getSofaRange().toUpperCase(),
		localizationEndpoints: ApplicationUtils.isProduction()
			? [
					'/addon-app/sofas/localizations/common/global/',
					'/addon-app/sofas/localizations/common/' +
						localeService.getCountryCode() +
						'/' +
						localeService.getLanguageCode() +
						'/',
					'/addon-app/sofas/localizations/first/global/',
					'/addon-app/sofas/localizations/first/' +
						localeService.getCountryCode() +
						'/' +
						localeService.getLanguageCode() +
						'/',
			  ]
			: [
					'https://www.ikea.com/addon-app/sofas/localizations/common/latest/global/',
					'https://www.ikea.com/addon-app/sofas/localizations/common/latest/' +
						localeService.getCountryCode() +
						'/' +
						localeService.getLanguageCode() +
						'/',
					'https://www.ikea.com/addon-app/sofas/localizations/first/latest/global/',
					'https://www.ikea.com/addon-app/sofas/localizations/first/latest/' +
						localeService.getCountryCode() +
						'/' +
						localeService.getLanguageCode() +
						'/',
					'https://www.ikea.com/addon-app/components/resources/endpoints/56/' +
						localeService.getCountryCode() +
						'/' +
						localeService.getLanguageCode() +
						'/local.development.proxy.json',
			  ],
		dexfConfigurationVersion: '1.0',
	},
	rangeSettings: null,
	sofaRange: 'vimle',
	predefinedConfigurations: [],
	features: null,
	kompisSettings: null,
};

export function settingsReducer(state = initialState, action: SettingsStateActions): SettingsState {
	switch (action.type) {
		case SET_SETTINGS:
			return {
				...state,
				settings: action.value.settings,
				rangeSettings: action.value.rangeSettings,
				predefinedConfigurations: action.value.predefinedConfigurations,
			};
		case SET_SOFA_RANGE:
			return { ...state, sofaRange: action.value };
		case SET_FEATURES:
			return { ...state, features: action.value };
		case SET_KOMPIS_SETTINGS:
			return { ...state, kompisSettings: action.value };
		default:
			return state;
	}
}
